const Gateways = () => import(/* webpackChunkName: "v-alarms" */ '@/components/page/alarms/Gateways')
const EndDevices = () => import(/* webpackChunkName: "v-alarms" */ '@/components/page/alarms/EndDevices')
const Network = () => import(/* webpackChunkName: "v-alarms" */ '@/components/page/alarms/Network')

const routes = [
  {
    path: 'alarms',
    redirect: 'gateways'
  }, {
    path: 'alarms/gateways',
    name: 'gatewaysAlarms',
    component: Gateways
  }, {
    path: 'alarms/end-devices',
    name: 'endDevicesAlarms',
    component: EndDevices
  }, {
    path: 'alarms/network',
    name: 'networkAlarms',
    component: Network
  }
]

export default routes
